export enum CPD_PROGRAMS {
  DIABETES_CLINICAL_EVALUATION_PROGRAM = 1,
  SKIN_PATHOLOGY_EVALUATION_PROGRAM = 2,
  CYTOLOGY_EVALUATION_PROGRAM = 3,
}
